import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ResetMailGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const allowed = sessionStorage.getItem('mailSent') === 'true';

    if (!allowed) {
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }
    return true;
  }
}
